var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastpageNavIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58917 0.00162569H6.54413C6.43566 0.00162569 6.33162 0.0447184 6.25492 0.121424C6.17821 0.19813 6.13512 0.302165 6.13512 0.410643V3.73595L0.633963 0.0547979C0.571786 0.0188992 0.501254 0 0.429459 0C0.357663 0 0.287132 0.0188992 0.224954 0.0547979C0.158724 0.0881475 0.102805 0.138876 0.063181 0.201555C0.0235568 0.264235 0.00171766 0.336508 0 0.410643V8.59098C0.000197432 8.66498 0.0204627 8.73753 0.0586369 8.80091C0.0968111 8.8643 0.151464 8.91614 0.216774 8.95092C0.280732 8.98376 0.352216 8.99916 0.424022 8.99557C0.495828 8.99198 0.56542 8.96952 0.625782 8.93047L6.12694 5.24931V8.59098C6.12694 8.69946 6.17003 8.8035 6.24674 8.8802C6.32344 8.95691 6.42747 9 6.53595 9H8.58099C8.68947 9 8.7935 8.95691 8.8702 8.8802C8.94691 8.8035 8.99 8.69946 8.99 8.59098V0.410643C8.99002 0.303567 8.94805 0.200753 8.87311 0.124278C8.79817 0.0478035 8.69622 0.00376719 8.58917 0.00162569Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastpageNavIconRight);
export default __webpack_public_path__ + "static/media/lastpageNavIcon-right.6b74df169c481e498028f8f7989a36b7.svg";
export { ForwardRef as ReactComponent };